import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { HiCheckCircle } from "react-icons/hi2";
import LoadingSpinner from "../components/LoadingSpinner";
import { SearchBar } from "../Dashboard-Seller/MyListings/components/SearchBar";
import NotFound from "./NotFound";

const ListingSelector = ({
  calledFrom,
  selectedListings = [],
  onSelectListing,
  maxListings = 20,
  minListings = 0,
  onUnselectListing,
  setActiveTab,
  activeIndex,
}) => {
  const [page, setPage] = useState(1);
  const [loader, setloader] = useState(false);
  const [FeaturedMockups, setFeaturedMockups] = useState([]);
  const { userid } = useSelector((state) => state.auth);
  const [hasNextPage, sethasNextPage] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [search, setsearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const isBundleStepper = calledFrom === "bundle-stepper";

  const isListingSelected = (listing) =>
    selectedListings.some((selected) => selected.id === listing.id);

  const handleAddClick = () => {
    setShowModal(true);
  };

  const handleSelect = (listing) => {
    if (isListingSelected(listing)) {
      onUnselectListing?.(listing);
      return;
    }
    if (selectedListings.length < maxListings) {
      onSelectListing(listing);
    }
  };

  const handleUnSelect = (listing) => {
    onUnselectListing(listing);
  };

  const fetchFeaturedMockups = async () => {
    try {
      setloader(true);
      const params = new URLSearchParams();
      if (appliedSearch) params.append("search", appliedSearch);
      params.append("page", String(page));
      const result = await apiClient.get(
        `/listings/?user_id=${userid}&${params.toString()}`
      );
      if (!result.ok) {
        setloader(false);
        return;
      }

      if (page === 1) {
        setFeaturedMockups(result.data.results);
      } else {
        setFeaturedMockups((prev) => [...prev, ...result.data.results]);
      }
      sethasNextPage(Boolean(result.data.next));
      setloader(false);
    } catch (error) {
      setloader(false);
      console.log("error", error);
    }
  };

  const handleApplySearch = (value) => {
    setFeaturedMockups([]);
    setloader(true);
    setAppliedSearch(value);
    setPage(1);
    sethasNextPage(true);
  };

  useEffect(() => {
    if (userid) {
      fetchFeaturedMockups();
    }
  }, [page, appliedSearch, userid]);

  const listingsHint = isBundleStepper
    ? `Add at least ${Math.max(minListings, 2)} listings (up to ${maxListings}).`
    : `Add up to ${maxListings} Listings`;

  return (
    <div className="row mb-4">
      {calledFrom === "multi-mockup-design-editor" ? (
        <>
          <div className="d-flex flex-column justify-content-between">
            <div className=" fs-6">
              <p className="fs-6">Add up to {maxListings} Listings</p>
            </div>
            <div className="">
              <div className="d-flex flex-wrap gap-2">
                {selectedListings.map((listing, index) => (
                  <div
                    key={index}
                    className="rounded position-relative me-2 mb-2 group"
                    style={{
                      width: "60px",
                      height: "60px",
                      overflow: "hidden",
                      border:
                        Number(activeIndex) === index
                          ? "2px solid #c93312"
                          : "2px solid #000",
                      boxSizing: "border-box",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => setActiveTab(index)}
                  >
                    <DeleteIcon
                      className=""
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUnSelect(listing);
                      }}
                      style={{
                        position: "absolute",
                        top: "2px",
                        left: "2px",
                        backgroundColor: "white",
                        color: "red",
                        borderRadius: "50%",
                        fontSize: "16px",
                        padding: "2px",
                        cursor: "pointer",
                        zIndex: 1,
                      }}
                    />

                    <img
                      src={
                        listing?.use_main_file_as_thumbnail
                          ? listing?.compressed_file
                          : listing?.thumbnails?.[0]?.image
                      }
                      alt={`listing-${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ))}

                {selectedListings.length < maxListings && (
                  <button
                    type="button"
                    onClick={handleAddClick}
                    className="d-flex justify-content-center align-items-center rounded border"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderWidth: "2px",
                      background: "#f7f7f7",
                    }}
                  >
                    <span style={{ fontSize: "24px", fontWeight: "bold" }}>
                      +
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="col-md-6 fs-6">
            <p className="fs-6 mb-1">{listingsHint}</p>
            {isBundleStepper && (
              <p
                className="text-muted mb-0 small"
                style={{ fontSize: "13px", maxWidth: "280px" }}
              >
                Use the red remove icon on each thumbnail to drop it from the
                bundle. Already-added mockups show a green check in the picker.
              </p>
            )}
          </div>
          <div className="col-md-6">
            <div
              className="d-flex flex-wrap gap-2 "
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {selectedListings.map((listing, index) => (
                <div
                  key={index}
                  className="rounded border position-relative me-2 mb-2 group"
                  style={{
                    width: "60px",
                    height: "60px",
                    overflow: "hidden",
                    borderWidth: "2px",
                    position: "relative",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveTab(index)}
                >
                  <DeleteIcon
                    aria-label={
                      isBundleStepper ? "Remove listing from bundle" : undefined
                    }
                    title={isBundleStepper ? "Remove" : undefined}
                    className={
                      isBundleStepper ? "" : "opacity-0 group-hover:opacity-100"
                    }
                    onClick={(e) => {
                      if (isBundleStepper) e.stopPropagation();
                      handleUnSelect(listing);
                    }}
                    style={{
                      position: "absolute",
                      top: "2px",
                      left: "2px",
                      backgroundColor: "white",
                      color: "red",
                      borderRadius: "50%",
                      fontSize: "16px",
                      padding: "2px",
                      cursor: "pointer",
                      zIndex: isBundleStepper ? 2 : 1,
                      ...(isBundleStepper
                        ? { boxShadow: "0 1px 3px rgba(0,0,0,0.2)" }
                        : {}),
                    }}
                  />

                  <img
                    src={
                      listing?.use_main_file_as_thumbnail
                        ? listing?.compressed_file
                        : listing?.thumbnails?.[0]?.image
                    }
                    alt={`listing-${index}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}

              {selectedListings.length < maxListings && (
                <button
                  type="button"
                  onClick={handleAddClick}
                  className="d-flex justify-content-center align-items-center rounded border"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderWidth: "2px",
                    background: "#f7f7f7",
                  }}
                >
                  <span style={{ fontSize: "24px", fontWeight: "bold" }}>
                    +
                  </span>
                </button>
              )}
            </div>
          </div>
        </>
      )}

      {showModal && (
        <div
          className="modal d-block"
          style={{ zIndex: 10000 }}
          tabIndex="-1"
          role="dialog"
          onClick={() => setShowModal(false)}
        >
          <div
            className="modal-dialog"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">Select a Listing</h5>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                  className="btn btn-sm btn-light"
                  style={{ lineHeight: 1, padding: "4px 10px" }}
                >
                  &times;
                </button>
              </div>
              <div className="mt-2 px-3" style={{ width: "100%" }}>
                <SearchBar
                  search={search}
                  setSearch={setsearch}
                  appliedSearch={appliedSearch}
                  onApply={handleApplySearch}
                  loading={loader && page === 1}
                />
                {loader && page === 1 && (
                  <p
                    className="mb-0 mt-2 text-muted"
                    style={{ fontSize: "13px" }}
                    aria-live="polite"
                  >
                    Searching listings…
                  </p>
                )}
              </div>
              <div
                className="modal-body"
                style={{
                  maxHeight: "300px",
                  overflowX: "auto",
                }}
                onScroll={(e) => {
                  if (loader || !hasNextPage) return;
                  const bottom =
                    e.target.scrollHeight - e.target.scrollTop <=
                    e.target.clientHeight + 8;

                  if (bottom) {
                    setPage((prev) => prev + 1);
                  }
                }}
              >
                {loader && page === 1 ? (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center py-5 w-100"
                    style={{ minHeight: "180px" }}
                  >
                    <LoadingSpinner color="#FF3E1F" />
                    <p className="mb-0 mt-3 text-muted" style={{ fontSize: "14px" }}>
                      Searching…
                    </p>
                  </div>
                ) : (
                <div
                  className="d-flex gap-3 flex-wrap"
                  style={{
                    overflowX: "auto",
                  }}
                >
                  {FeaturedMockups?.length ? (
                    FeaturedMockups.map((listing, idx) => {
                      const alreadyAdded = isListingSelected(listing);
                      return (
                        <div
                          key={listing?.id ?? idx}
                          className="rounded d-flex flex-column align-items-center"
                          style={{
                            cursor: "pointer",
                            width: "100px",
                          }}
                          onClick={() => handleSelect(listing)}
                        >
                          <div
                            className="position-relative"
                            style={{
                              width: "100px",
                              height: "100px",
                              overflow: "hidden",
                              borderRadius: "6px",
                              border: alreadyAdded
                                ? "2px solid #1f8a3b"
                                : "2px solid transparent",
                              boxSizing: "border-box",
                            }}
                          >
                            <img
                              src={
                                listing?.use_main_file_as_thumbnail
                                  ? listing?.compressed_file
                                  : listing?.thumbnails?.[0]?.image
                              }
                              alt={`Item ${idx}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                            {alreadyAdded && (
                              <HiCheckCircle
                                aria-label="Already added to bundle"
                                title="Already added"
                                style={{
                                  position: "absolute",
                                  top: "4px",
                                  right: "4px",
                                  width: "22px",
                                  height: "22px",
                                  color: "#1f8a3b",
                                  backgroundColor: "#fff",
                                  borderRadius: "50%",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                                }}
                              />
                            )}
                          </div>
                          <p
                            style={{
                              marginTop: "4px",
                              fontSize: "12px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "100px",
                              color: alreadyAdded ? "#1f8a3b" : undefined,
                              fontWeight: alreadyAdded ? 600 : undefined,
                            }}
                            title={listing?.title}
                          >
                            {alreadyAdded ? "Added" : listing?.title}
                          </p>
                        </div>
                      );
                    })
                  ) : (
                    <NotFound
                      hasActiveSearch={Boolean(appliedSearch?.trim())}
                    />
                  )}
                  {loader && page > 1 && (
                    <div className="d-flex justify-content-center align-items-center w-100 mt-3 mb-2">
                      <LoadingSpinner color="#FF3E1F" />
                    </div>
                  )}
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListingSelector;
